import React from "react";
import "./style.css";

const ToggleSwitch = ({ name, id, checked, onChange, disabled = false }) => {
	return (
		<label htmlFor={id} className="switch">
			<input
				type="checkbox"
				id={id}
				name={name}
				checked={checked}
				onChange={onChange}
				disabled={disabled}
			/>

			<span className="slider round" />
		</label>
	);
};

export default ToggleSwitch;
